<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<!-- should technically slap a loading spinner over this page until application.asyncSelectionLoaded is true
but the worst case if we don't is that any selections the user made instantly after opening the dialog might be replaced by the db ones
I... think we'll survive -->
<div class="app-org-tab-content-container org-app-projects" *ngIf="(projects$ | async)?.length">
	<div class="description-text">{{ appStrings.ORG_TEXT_DESCRIPTION }}</div>
	<mat-radio-group
		class="radio-select-section"
		[formControl]="inheritProjects"
		automationId="projectsRadioGroup"
	>
		<mat-radio-button [value]="true">All organization projects</mat-radio-button>
		<mat-radio-button [value]="false">Selected projects</mat-radio-button>
	</mat-radio-group>

	<!-- If the all checkbox is enabled will get a fake list of checkboxes (separate the visual from the data) -->
	<ng-container *ngIf="inheritProjects.value">
		<section *ngFor="let appProject of projects$ | async">
			<mat-checkbox checked="true" disabled="true">
				<mat-label class="label-spacing">{{ appProject?.view?.project?.projectName }}</mat-label>
			</mat-checkbox>
		</section>
	</ng-container>
	<!-- And the real one -->
	<ng-container *ngIf="!inheritProjects.value" [formGroup]="projectsFormGroup">
		<section *ngFor="let appProject of projects$ | async">
			<mat-checkbox [formControl]="projectsFormGroup.get(appProject.$id)">
				<mat-label class="label-spacing">{{ appProject?.view?.project?.projectName }}</mat-label>
			</mat-checkbox>
		</section>
	</ng-container>
</div>
<div
	class="app-org-tab-content-container org-app-projects"
	*ngIf="!(projects$ | async)?.length"
	automationId="noOrgProjects"
>
	No projects exists
</div>
